import { Col, Flex, Image, Row, Tag } from "antd";
import icon from "../../../assets/images/direct.svg"
import { useMediaQuery } from "react-responsive";
import { setIsLoading, setLoanDetails } from "../slices/webappSlice";
import { getLoanDetails } from "../services/webAppApi";
import { useDispatch, useSelector } from "react-redux";
import { generateRandomString } from "utils/helper";
import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import { useTranslation } from "react-i18next";
import { setLoanTransferStatus } from "../../whiteList/slices/whiteListSlice";
import * as services from "../../whiteList/services/whiteListApi";

const useComplete = () => {
    const { t, i18n } = useTranslation();
    const isPortrait = useMediaQuery({ orientation: 'portrait' })
    const location = useLocation()
    // console.log("location", location);
    const dispatch = useDispatch()
    const { isLoading, loanDetails } = useSelector((state) => state.webapp);
    const { loanTransferStatus } = useSelector((state) => state?.whitelist)

    const serviceLoanDetails = async (params) => {
        try {
            dispatch(setIsLoading(true));
            const response = await getLoanDetails({
                ...params,
                requestId: generateRandomString(),
                txnId: location?.state?.txnId
            })
            console.log("response service loan", response);
            console.log("data", response.data);
            dispatch(setLoanDetails(response?.data?.content))
        } catch (error) {
            alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    }
    console.log("logggggggg loan detaillll", loanDetails);


    const getLoanTransferStatus = useCallback(async () => {
        dispatch(setIsLoading(true));
        try {
            const response = await services.getLoanTransferStatus({
                employeeNo: "202020",
                page: "0",
                size: "10"
            });

            console.log("tranfer statusss", loanTransferStatus);
            dispatch(setLoanTransferStatus(response?.data?.content));
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(setIsLoading(false));
        }
    }, []);

    function tagContractStatus(transferStatus) {
        // console.log("transfertag testt", loanDetails?.transferStatus, );
        let info = loanTransferStatus.find(o => o.code == transferStatus)

        switch (transferStatus) {
            case "WAITING":
                return (
                    <Tag color="geekblue">{i18n.language === "en" ? info?.nameEN : info?.name}</Tag>
                )
            case "TRANSFERED":
                return (
                    <Tag color="success">{i18n.language === "en" ? info?.nameEN : info?.name}</Tag>
                )
            case "EXPORTED":
                return (
                    <Tag color="default">{i18n.language === "en" ? info?.nameEN : info?.name}</Tag>
                )
            default: return ("")
        }
    }

    useEffect(() => {
        serviceLoanDetails()
        getLoanTransferStatus()
    }, [])

    function headPart() {
        return (
            <Flex vertical>
                <Flex>
                    <span style={{ color: "#646464", fontWeight: "bold", }}>รายละเอียดสัญญา</span>
                </Flex>
                <Row style={{ height: isPortrait ? "5vh" : "8vh", justifyContent: "center", alignContent: "center" }}>
                    <Col span={12}>
                        <Flex vertical style={{ color: "#909090", }}>
                            <span>เลขที่สัญญา</span>
                            <span>{loanDetails?.requestCode}</span>
                        </Flex>
                    </Col>
                    <Col span={12}>
                        <Flex style={{ color: "#909090", textAlign: "right", flexDirection: "column", alignItems: "flex-end" }}>
                            <span>สถานะ</span>
                            {tagContractStatus(loanDetails?.transferStatus)}
                        </Flex>
                    </Col>

                </Row>
            </Flex>
        )
    }
    function first() {
        return (
            <Flex vertical style={{
                backgroundColor: "white", borderRadius: "2vh", padding: isPortrait ? "2vh" : "2.5vw", color: "#909090"
            }}>
                <Row>
                    <Col span={12}><span>วันที่เปิดสัญญา</span></Col>
                    <Col span={12} style={{ textAlign: "right" }}><span>{dayjs(loanDetails?.requestDate).format("DD MMM BBBB")}</span></Col>
                </Row>
                <Row>
                    <Col span={12}><span>ยอดรวมรายการ</span></Col>
                    <Col span={12} style={{ textAlign: "right" }}><span>{get2DecimalPointsWithCommas(loanDetails?.creditUsage) + " บาท"}</span></Col>
                </Row>
                <Row>
                    <Col span={12}><span>ระยะเวลาเเบ่งชำระ</span></Col>
                    <Col span={12} style={{ textAlign: "right" }}><span>{loanDetails?.period + " เดือน"}</span></Col>
                </Row>
                <Row>
                    <Col span={12}><span>ยอดชำระต่องวด</span></Col>
                    <Col span={12} style={{ textAlign: "right" }}><span>{get2DecimalPointsWithCommas(loanDetails?.creditUsage + loanDetails?.fee) + " บาท"}</span></Col>
                </Row>
                <Row>
                    <Col span={12}><span>ดอกเบี้ย</span></Col>
                    <Col span={12} style={{ textAlign: "right" }}><span>{get2DecimalPointsWithCommas(loanDetails?.interest) + " บาท"}</span></Col>
                </Row>
                <Row>
                    <Col span={12}><span>ค่าธรรมเนียม</span></Col>
                    <Col span={12} style={{ textAlign: "right" }}><span>{get2DecimalPointsWithCommas(loanDetails?.fee) + " บาท"}</span></Col>
                </Row>
            </Flex>
        )
    }
    function second() {
        return (
            <Flex vertical style={{
                backgroundColor: "white", borderRadius: "2vh", padding: isPortrait ? "2vh" : "2.5vw", color: "#909090"
            }}>
                <Row>
                    <Col span={12}><span>ยอดคงเหลือที่ต้องชำระ</span></Col>
                    <Col span={12} style={{ textAlign: "right" }}><span>{get2DecimalPointsWithCommas(loanDetails.balancePaid) + " บาท"}</span></Col>
                </Row>
                <Row>
                    <Col span={12}><span>วันที่ชำระครั้งถัดไป</span></Col>
                    <Col span={12} style={{ textAlign: "right" }}><span>-</span></Col>
                </Row>
                <Row>
                    <Col span={12}><span>ยอดชำระครั้งถัดไป</span></Col>
                    <Col span={12} style={{ textAlign: "right" }}><span>{get2DecimalPointsWithCommas(loanDetails.nextBalancePaid) + " บาท"}</span></Col>
                </Row>
            </Flex>
        )
    }
    function third() {
        return (
            <Flex vertical style={{
                backgroundColor: "white", borderRadius: "2vh", padding: isPortrait ? "2vh" : "2.5vw", height: isPortrait ? "30vh" : "30vw", width: "100%", display: "flex", justifyContent: "center", alignItems: "center"
            }}>
                <Row style={{ width: "100%", justifyContent: "flex-start" }}>
                    <span style={{ color: "#909090", }}>ข้อมูลการรับชำระ</span>
                </Row>
                <Flex vertical style={{ height: "36vh", justifyContent: "center", alignContent: "center", width: "100%" }}>
                    <Row span={22} style={{ textAlign: "center", justifyContent: "center" }}>
                        <Image
                            preview={false}
                            width={isPortrait ? "10vh" : "10vw"}
                            src={icon}
                        />
                    </Row>
                    <Row style={{ textAlign: "center", height: "1vh", justifyContent: "center", alignItems: "center" }}>
                        <Flex vertical style={{ color: "#D9D9D9", }}>
                            <span>ไม่พบข้อมูล</span>
                        </Flex>
                    </Row>
                </Flex>
            </Flex>
        );
    }


    return {
        headPart,
        first,
        second,
        third,
    }
}
export default useComplete;